module.exports = __webpack_public_path__ + "static/media/Blank.8bcd2d4e.logo";